import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import { useAuthStore } from '../store/authStore';
import { usePermissions } from './usePermissions';

/**
 * P-33c (D-188) — the company's organization id: OTE is the company, not a
 * customer, so its customer page is hidden and links to it are plain text
 * "OTE, עבודה פנימית". Same query key as the task picker (P-33a), so nothing
 * is fetched twice. An internal-only employee gets it from `/permissions/me`.
 */
export function useInternalOrgId(): string | null {
  const isStaff = useAuthStore((s) => s.user?.role === 'admin' || s.user?.role === 'agent');
  const { internalOnly, internalWorkOrganizationId } = usePermissions();
  const q = useQuery({
    queryKey: ['engagements', 'internal-work'],
    queryFn: () => api.getInternalWork(),
    staleTime: 5 * 60_000,
    enabled: isStaff && !internalOnly,
  });
  return internalOnly ? internalWorkOrganizationId : q.data?.data?.organization_id ?? null;
}
